export default __webpack_public_path__ + "6dfe305036de732496a769b707c474f1.png";